import * as t from 'lib/t';
import EmptyObject from 'lib/EmptyObject';
import EmptyArray from 'lib/EmptyArray';
import Falsy from 'lib/falsy';
import BooleanString from 'lib/BooleanString';

export default function cleanQuery(query) {
  if (t.Nil.is(query)) {
    return query;
  }

  let q = query;

  Object.keys(q).forEach((key) => {
    let o = q[key];

    // Pattern match on value
    t.match(
      o,
      EmptyObject,
      () => {
        delete q[key];
      },
      EmptyArray,
      () => {
        delete q[key];
      },
      // Delete properties with falsy or empty values.
      Falsy,
      () => {
        // Delete the falsy value
        delete q[key];
      },
      BooleanString,
      () => {
        // TODO: test
        q[key] = q[key] === 'true';
      },
      t.Object,
      () => {
        // Recurse over the object
        let res = cleanQuery(o);
        if (EmptyObject.is(res) || Falsy.is(res)) {
          delete q[key];
        } else {
          q[key] = res;
        }
      },
      t.Number,
      () => {
        // Cast the numbers to string
        q[key] = String(o);
      },
      t.Any,
      () => {}
    );
  });
  return q;
}
